import React, {useContext} from 'react'
import FavoriteItem from '../components/FavoriteItem/FavoriteItem.jsx'
import { StateContext } from '../context/GlobalState.jsx'

function Wishlist() {
    // consuming contexts
    let {favoriteItems} = useContext(StateContext);
    favoriteItems = favoriteItems ? favoriteItems : [{}];
    
    return (
        <section className="wishlist-section">
            {
                favoriteItems.map(item => <FavoriteItem key={item.ID} item={item} /> )
            }
            <br/><br/> <br/><br/> <br/><br/> <br/><br/>
        </section>
    )
}

export default Wishlist
